var _defs, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path6, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.28 583.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#2b2b2b;}.cls-2{stroke:#2b2b2b;stroke-linecap:round;stroke-miterlimit:10;stroke-width:6.97px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.09,24.94c36.3-3.61,67.13,22.47,70.14,58.58l-.03,282.85c10.44,12.26,21.27,21.59,28.44,36.83,38.38,81.62-38.39,168.89-124.38,140.42-61.89-20.49-88.14-96.64-52.26-151.36,6.61-10.08,15.22-16.63,22.21-25.88l-.03-282.85c1.7-29.68,26.27-55.64,55.92-58.58ZM202.21,36.37c-24.44,2.68-44.45,23.67-45.6,48.3l-.02,286.25c-.72,4.63-13.09,13.68-17.08,18.42-56.46,67.13,6.79,167.31,91.58,145.4,63.75-16.48,88.09-95.07,45.76-145.4-3.99-4.74-16.35-13.79-17.08-18.42-1.13-98.66,1.94-197.73-1.55-296.16-6.55-24.91-30.27-41.21-56.02-38.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.27,107.32c8.4-8.38,40.98,14.26,51.18,16.4,20.62,4.33,39.44-20.33,63.5-17.69,16.06,1.76,32.51,17.76,47.06,18.27,17.23.61,41.15-22.54,55.88-18.15,5.13,1.53,5.15,8.62.82,10.64-2.26,1.06-4.87.21-7.18.84-19.63,5.33-33.67,21.56-55.87,17.53-14.53-2.64-31.05-17.84-45.17-17.9-12.71-.05-27.31,12.33-40.06,16.14-26.84,8.03-37.81-9.11-60.98-15.77-2.22-.64-4.73.17-7.15-.87-3.37-1.46-4.7-6.78-2.03-9.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.09,162.25c13.58-4.02,37.3,17.28,52.39,18.15,16.97.98,33.65-16.86,51.57-18.37,23.97-2.01,41.11,22.75,63.33,17.52,12.79-3.01,34.77-21.09,47.49-17.3,1.64.49,4.18,3.14,4.22,4.88.19,7.23-11.92,6.93-17.47,8.87-16.55,5.81-26.18,17.68-46.05,15.76-16.01-1.55-33.11-18.4-48.1-18.4-14,0-30.7,15.27-45.17,17.9-21.37,3.88-31.39-9.08-48.98-15.26-4.64-1.63-14.29-2.09-16.41-5.34-2.09-3.2-.52-7.33,3.17-8.42Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.26,228.15c-2.92-2.87-1.04-8.65,2.83-9.8,12.65-3.75,36.83,16.23,50.23,17.99,19.89,2.6,36.96-19.16,58.33-18.28,19.3.8,35.5,19.7,53.84,18.42,14.94-1.04,39.27-22.17,52.4-18.15,1.91.58,4.26,4.18,4.21,6.11-.15,5.6-12.71,6-17.47,7.67-17.09,6-26.39,18.03-47.08,15.65-15.45-1.78-32.23-18.28-47.07-18.28-12.92,0-28.71,13.47-41.55,16.93-24.46,6.6-34.72-8.46-55.26-15.07-3.16-1.02-12.11-1.91-13.41-3.18Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.47,407.96l.26-300.32c3.22-35.56,50.67-35.74,54.8-1.02l.73,300.41c43.64,32.54,12.58,101.32-40.9,87.85-39.5-9.95-49.53-64.71-14.9-86.92ZM224.22,132.24v-24.62c0-.37-1.69-6.42-2.02-7.14-4.82-10.52-21.83-10.84-27.6-.72-.45.79-2.44,6.31-2.44,6.72v25.76h32.06ZM224.22,412.2V145.41l-1.72-1.72h-28.63l-1.72,1.72v266.8c0,1.69-11.26,9.27-13.74,12.6-19,25.54-.3,61.42,31.54,60.16,30.11-1.19,45.86-36.16,28-60.16-2.78-3.74-13.36-10.41-13.74-12.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.44,
    y: 81.45,
    width: 63.46,
    height: 11.6,
    rx: 5.19,
    ry: 5.19
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.44,
    y: 159.38,
    width: 63.46,
    height: 11.6,
    rx: 5.19,
    ry: 5.19
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.44,
    y: 234.87,
    width: 63.46,
    height: 11.6,
    rx: 5.19,
    ry: 5.19
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.44,
    y: 314.01,
    width: 63.46,
    height: 11.6,
    rx: 5.19,
    ry: 5.19
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 81.5,
    y: 275.05,
    width: 36.4,
    height: 11.6,
    rx: 5.41,
    ry: 5.41
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 81.5,
    y: 197.13,
    width: 36.4,
    height: 11.6,
    rx: 5.41,
    ry: 5.41
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 81.5,
    y: 120.42,
    width: 36.4,
    height: 11.6,
    rx: 5.41,
    ry: 5.41
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M442.35,504.04c-1.36,0-2.72-.04-4.1-.11h0c-40.33-2.24-71.32-36.87-69.09-77.2,1.08-19.54,9.71-37.48,24.29-50.53,14.58-13.05,33.36-19.64,52.91-18.55,19.54,1.08,37.48,9.71,50.53,24.29,13.05,14.58,19.64,33.37,18.55,52.91-2.16,38.95-34.55,69.2-73.1,69.2ZM438.72,495.42c35.65,1.95,66.24-25.41,68.22-61.05.96-17.26-4.87-33.87-16.4-46.75-11.53-12.89-27.39-20.51-44.65-21.47-17.26-.96-33.87,4.87-46.75,16.4-12.88,11.53-20.51,27.39-21.47,44.65-1.98,35.64,25.41,66.24,61.05,68.22h0Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 389.5,
    y1: 480.59,
    x2: 370.75,
    y2: 498.59
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 371.23,
    y1: 447.4,
    x2: 345.99,
    y2: 453.61
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 372.01,
    y1: 409.52,
    x2: 347.04,
    y2: 402.28
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 391.62,
    y1: 377.1,
    x2: 373.62,
    y2: 358.35
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 424.81,
    y1: 358.83,
    x2: 418.6,
    y2: 333.59
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 462.69,
    y1: 359.61,
    x2: 469.93,
    y2: 334.64
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 495.1,
    y1: 379.22,
    x2: 513.86,
    y2: 361.21
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 513.37,
    y1: 412.41,
    x2: 538.62,
    y2: 406.19
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 512.6,
    y1: 450.29,
    x2: 537.57,
    y2: 457.53
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 492.99,
    y1: 482.7,
    x2: 510.99,
    y2: 501.46
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 459.8,
    y1: 500.97,
    x2: 466.01,
    y2: 526.21
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 421.92,
    y1: 500.2,
    x2: 414.68,
    y2: 525.17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.a8aa6b5e11e9bd20bef894c19682d100.svg";
export { ForwardRef as ReactComponent };